(function () {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function setOpen(target, className, bodyClass, open) {
    if (!target) return;
    target.classList.toggle(className, open);
    document.body.classList.toggle(bodyClass, open);
  }

  document.addEventListener("click", (event) => {
    const openMenu = event.target.closest("[data-open-menu]");
    const closeMenu = event.target.closest("[data-close-menu]");
    const openFilters = event.target.closest("[data-open-filters]");
    const closeFilters = event.target.closest("[data-close-filters]");

    if (openMenu) setOpen(qs("[data-mobile-drawer]"), "is-open", "drawer-open", true);
    if (closeMenu) setOpen(qs("[data-mobile-drawer]"), "is-open", "drawer-open", false);
    if (openFilters) setOpen(qs("[data-facets]"), "is-open", "filters-open", true);
    if (closeFilters) setOpen(qs("[data-facets]"), "is-open", "filters-open", false);

    if (event.target.matches(".drawer-open") && !event.target.closest("[data-mobile-drawer]")) {
      setOpen(qs("[data-mobile-drawer]"), "is-open", "drawer-open", false);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    setOpen(qs("[data-mobile-drawer]"), "is-open", "drawer-open", false);
    setOpen(qs("[data-facets]"), "is-open", "filters-open", false);
  });

  qsa('form[role="search"]').forEach((form) => {
    form.addEventListener("submit", (event) => {
      const input = qs('input[name="q"]', form);
      if (input && input.value.trim().length === 0) {
        event.preventDefault();
        input.focus();
      }
    });
  });

  qsa("[data-sort-select]").forEach((sort) => {
    sort.addEventListener("change", () => {
      const form = qs("[data-facet-form]");
      if (form) {
        const sortInput = qs('input[name="sort_by"]', form);
        if (sortInput) sortInput.value = sort.value;
        form.submit();
        return;
      }

      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", sort.value);
      window.location.href = url.toString();
    });
  });

  qsa(".rt-product-thumb").forEach((thumb) => {
    thumb.addEventListener("click", (event) => {
      const main = qs(".rt-product-gallery__main img");
      const img = qs("img", thumb);
      if (!main || !img) return;
      event.preventDefault();
      main.src = thumb.href;
      main.alt = img.alt;
      qsa(".rt-product-thumb").forEach((item) => item.classList.remove("is-active"));
      thumb.classList.add("is-active");
    });
  });
})();
